import React from "react";
import { Icon } from "semantic-ui-react";

import { ProductsTableActions } from "./ProductsTableActions";

export const getProductsTableColumns = () => {
  return [
    {
      header: "ID",
      id: "ID",
      accessorKey: "id",
      size: 60,
      cell: ({ row }) => (
        <p style={{ fontWeight: "bold" }}>{row.original?.id}</p>
      ),
    },
    {
      header: "Name",
      id: "Name",
      accessorKey: "name",
    },
    {
      header: "List Price",
      id: "List Price",
      accessorKey: "list_price",
    },
    {
      header: "Enabled",
      id: "Enabled",
      accessorKey: "enabled",
      size: 80,
      cell: ({ row }) => (
        <Icon
          name={row.original.enabled ? "check" : "close"}
          color={row.original.enabled ? "green" : "red"}
        />
      ),
    },
    {
      header: <div></div>,
      id: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      enableResizing: false,
      size: 60,
      meta: {
        isDisplay: true,
      },
      cell: ({ row }) => <ProductsTableActions original={row.original} />,
    },
  ];
};

export const getProductsTableFilters = () => [
  {
    key: "list_price",
    title: "List Price",
    type: "range",
  },
  {
    key: "enabled",
    title: "Status",
    type: "select",
    data: [
      { id: true, name: "Enabled" },
      { id: false, name: "Disabled" },
    ],
  },
];
